var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlertAnnotationEnd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 28,
    viewBox: "0 0 27 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 13.5,
    cy: 13.625,
    r: 13.5,
    fill: "#EEF4DB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.44934 14.5648L11.7041 17.7545L18.9707 10.6328",
    stroke: "#008A15",
    strokeWidth: 1.81486,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertAnnotationEnd);
export default __webpack_public_path__ + "static/media/AlertAnnotationEnd.0e830f1618e7dffa40d8adce317d61c7.svg";
export { ForwardRef as ReactComponent };